import React, { FC, useState } from 'react'
import { Tabs } from '@components/UIKit/Tabs/Tabs'
import { ITabItem } from '@specs/types'

interface Props {
}

export const TabItems: FC<Props> = ({}) => {
    const [activeTab, setActiveTab] = useState('login')

    const tabs: ITabItem[] = [
        {
            text: 'auth.page.tab.login',
            onClick: async () => {
                setActiveTab('login')
            },
            href: '#',
            as: '',
            isActive: activeTab === 'login',
        },
        {
            text: 'auth.page.tab.register',
            onClick: async () => {
                setActiveTab('register')
            },
            href: '#',
            as: '',
            isActive: activeTab === 'register',
        },
    ]

    return (
        <Tabs tabs={tabs} />
    )
}
